import React from 'react';

import { HomepageUpsell, StickyOnsiteMessage } from '@zillow/zrs-cms-messaging';
import { isEmpty } from 'lodash';

import { ompNewLaneProps } from '../../constants/newLane';
import { useGlobalStoreState } from '../../contexts/GlobalStoreProvider';
import { AllHopsPlacements } from '../../types/genericTypes';

const PLACEMENT_NAME = AllHopsPlacements.HOME_PAGE_STICKY_SLOT;
const triggerProps = ompNewLaneProps[PLACEMENT_NAME];

const StickyUpsell: React.FC = () => {
    const { onsiteMessages } = useGlobalStoreState();
    const originalPosition = {
        bottom: '$spacing.md',
        right: '$spacing.md',
    };

    if (isEmpty(onsiteMessages)) {
        return null;
    }

    return (
        <StickyOnsiteMessage
            messageData={onsiteMessages}
            placementName={PLACEMENT_NAME}
            supportedComponents={{ HomepageUpsell }}
            triggerLocation={triggerProps.triggerLocation}
            triggerObject={triggerProps.triggerObject}
            triggerSource={triggerProps.triggerSource}
            verticalProperty="bottom"
            horizontalProperty="right"
            verticalPosition={originalPosition.bottom}
            horizontalPosition={originalPosition.right}
        />
    );
};

export default StickyUpsell;
